import { Container, Text } from "@mantine/core";
import { dateFormat } from "../../../helpers/Helpers";
import { Link } from "react-router-dom";

import './ContestCard.css';

export default function ContestCard({ contest }) {
  const contestLink = `/contest/${contest.name}`;
  
  // Convert PostgreSQL timestamps to JavaScript Date objects
  const contestStartTime = new Date(contest.startat).getTime();
  const contestEndTime = new Date(contest.endat).getTime();
  const currentTime = Date.now();
  
  const status = contestEndTime < currentTime ? "Ended" : contestStartTime < currentTime ? "Ongoing" : "Starting";
  return (
    <Link to={contestLink}>
      <Container py="sm" pl="xl" className="border-top-gray contest-container">
        <Text size="lg" weight="bolder">
          {contest.name}
        </Text>
        <Text size="md">{status} {status === "Starting" ? dateFormat(new Date(contest.startat)) : dateFormat(new Date(contest.endat))}</Text>
      </Container>
    </Link>
  );
}